<template>
  <div class="home">
    <BannerHome/>
    <InfoHome/>
    <ProgramacaoHome/>
  </div>
</template>

<script>
import BannerHome from '@/wrappers/BannerHome'
import InfoHome from '@/wrappers/InfoHome'
import ProgramacaoHome from '@/wrappers/ProgramacaoHome'

export default {
  name: 'Home',
  components: {
    BannerHome,
    InfoHome,
    ProgramacaoHome,
  },
  mounted() {
    const anchor = this.$router.currentRoute.hash
    this.$nextTick(() => {
      if (anchor && document.querySelector(anchor)) {
        setTimeout(function() {
          location.href = anchor
        }, 50)
      }
    })
  }
}
</script>
